import { Channel } from '../../../../models/channel.enum';
import { type IChannel } from '../../../../models/channel.model';

export default class ChannelApiModel {
  public static mapToBusinessModel(apiModel: ChannelApiModel): IChannel {
    return {
      id: apiModel.id,
    };
  }

  id!: Channel;
}
